import { z } from "zod";

export const createTeamSchema = z.object({
  name: z.string().min(1, { message: "Nome é obrigatório" }),
  sectorId: z
    .string()
    .optional()
    .refine((val) => val && val.length > 0, {
      message: "Setor é obrigatório",
    }),
  regional: z.string().min(1, { message: "Regional é obrigatório" }),
  leaderId: z
    .string()
    .optional()
    .refine((val) => val && val.length > 0, {
      message: "Líder é obrigatório",
    }),
  workShift: z.enum(["MORNING", "AFTERNOON", "NIGHT", "FULL_TIME"], {
    message: "Turno de trabalho é obrigatório",
  }),
  status: z.enum(["ACTIVE", "INACTIVE"], {
    message: "Status é obrigatório",
  }),
  memberIds: z.array(z.string()),
  categoryIds: z.array(z.string()),
});

export const updateTeamSchema = createTeamSchema;

export type CreateTeamFormData = z.infer<typeof createTeamSchema>;
export type UpdateTeamFormData = z.infer<typeof updateTeamSchema>;
